import { useEffect } from "react";

import { CAMPAIGN_MESSAGE_TYPE_OPTIONS } from "@regal-voice/shared-types/entities";
import { Select } from "antd";
import { clsx } from "clsx";

import { RVFormFloatingLabelWrap } from "@regal-voice/ui";

import { CallFormItems } from "../../CallFormItems/CallFormItems";

import type { FormInstance } from "antd";

import styles from "../CancelTaskFormItems.module.scss";

type CampaignCancelProps = {
    formValues: Record<string, any>;
    form: FormInstance;
};

export function CancelCampaignTypeFormItems({ formValues = {}, form }: CampaignCancelProps): JSX.Element {
    const { campaignChannel } = formValues;

    // we need to reset the form fields when cancelType changes
    // this is a hack to get around our double storage, and making sure we don't have stale data
    useEffect(() => {
        form.setFieldsValue({ campaign: undefined });
        // we only want to observe campaignChannel
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [campaignChannel]);

    return (
        <>
            <RVFormFloatingLabelWrap
                name="campaignChannel"
                label="Channel"
                rules={[
                    {
                        required: true,
                        message: "Select Campaign Channel",
                    },
                ]}
            >
                <Select>
                    <Select.Option value={CAMPAIGN_MESSAGE_TYPE_OPTIONS.phone_call}>Phone Call</Select.Option>
                    <Select.Option value={CAMPAIGN_MESSAGE_TYPE_OPTIONS.sms}>SMS</Select.Option>
                </Select>
            </RVFormFloatingLabelWrap>

            <CallFormItems
                callType={campaignChannel}
                showLabel={false}
                showCampaignEditLink={false}
                isCanceledNode={true}
            />
            <span className={clsx(styles.infoSpan, styles.campaignInfoSpan)}>
                For a given contact, cancels all tasks from the queue associated with the campaign selected. Automated
                campaigns cannot be canceled.
            </span>
        </>
    );
}
